import { Box, Icon, ModalHeader, PrimaryButton, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'
import { Trans } from 'react-i18next'

import { Proposal } from '../../domain'
import {
  TKeyBuilder,
  useWriskTranslation,
} from '../../infrastructure/internationalisation'

export interface PrefillModalSuccessProps {
  tKey: TKeyBuilder
  proposal: Proposal
  onSuccess: (proposal: Proposal) => void
}

export const PrefillModalSuccess: FunctionComponent<PrefillModalSuccessProps> = ({
  proposal,
  onSuccess,
  tKey,
}) => {
  const { t } = useWriskTranslation()

  const header = (
    <Box
      display='flex'
      alignItems='center'
      width={1}
      columnGap={4}
      justifyContent='flex-start'
    >
      <Icon icon='tickFilled' size='large' />
      <Typo variant='heading' typoSize='xl'>
        {t(tKey('modals', 'success', 'header'))}
      </Typo>
    </Box>
  )

  const subheader = <Trans t={t} i18nKey={t(tKey('modals', 'success', 'subheader'))} />

  const handleClick = useCallback(() => {
    onSuccess(proposal)
  }, [proposal, onSuccess])

  return (
    <ModalHeader
      header={header}
      subheader={subheader}
      lowerContent={
        <PrimaryButton onClick={handleClick} mt={6}>
          {t(tKey('modals', 'success', 'actions', 'continue'))}
        </PrimaryButton>
      }
    />
  )
}
